<template>
  <!-- Úvodní stranka s komponenty -->
  <v-container>
    <div class="d-flex flex-wrap">
      <div v-for="item in CompList" :key="item.name" :value="item.name">
        <v-hover v-if="item.menuvisibility" v-slot="{ hover }">
          <v-card
            :img="AssetsUrl + '/' + item.menuimage"
            class="d-flex flex-column ma-1 pa-1"
            rounded="lg"
            :width="item.menuwidth ?  item.menuwidth : 250"
            :min-height="$vuetify.breakpoint.xs ? 0 : 300"
            @click="VybComp = item.name"
            :elevation="hover ? 24 : 6"
            outlined
          >
            <div
              class="ma-1 rounded-lg"
              style="background-color: rgba(0, 0, 0, 0.7)"
            >
              <div class="d-flex justify-end">
                <v-avatar
                  ><v-icon large>{{ item.icon }}</v-icon></v-avatar
                >
              </div>
              <v-card-title
                class="justify-center accent--text pt-0 text-center"
                v-html="item.title"
              />
            </div>

            <v-spacer />

            <div
              class="ma-1 rounded-lg"
              style="background-color: rgba(0, 0, 0, 0.7)"
            >
              <v-card-text class="text-center" v-html="item.description" />
            </div>
          </v-card>
        </v-hover>
      </div>
    </div>
  </v-container>
</template>

<script>
export default {
  data() {
    return {};
  },

  props: {
    // Adresa na Assets
    AssetsUrl: null,

    // Seznam  komponent
    CompList: { type: Array },
  },
  methods: {},

  computed: {
    // Změna vybrané komponenty podle jména
    VybComp: {
      get() {
        return this.$store.getters.GET_sVybComp;
      },
      set(newValue) {
        this.$store.commit("SET_sVybComp", {
          CompName: newValue,
          SlotName: this.CompList.find((item) => item.name == newValue).slot,
        });
      },
    },
  },
};
</script>